module.exports = __webpack_public_path__ + "img/wanjia.c006e313.png";